import { KYMW0D00InputModel } from './vo/kymw0d00-input.model';
import { KYMW0D00Component } from './kymw0d00.component';

/**
 * データ区分
 DATA_DIV_KYMW2900_PLAN_GOODS：農産フロント連携画面・商品企画
 DATA_DIV_KYMW2900_COMMENT：農産フロント連携画面・産地コメント
 DATA_DIV_KYMW9400_CATALOG：外部システム連携画面・営業カレンダー
 DATA_DIV_KYMW9400_USE_NUM_PEOPLE：外部システム連携画面・利用予算
 DATA_DIV_KYMW9400_DISTRIBUTION：外部システム連携画面・按分比率
 DATA_DIV_KYMW9400_BUDGET：外部システム連携画面・予算
 DATA_DIV_KYMW6300_JANCODE：EC外部システム連携画面・JANコード
 DATA_DIV_KYMW2700_PAGE_CHECK：基版コピー・フェーズ管理画面・全ページチェック
 DATA_DIV_KYMW2700_PHASE：基版コピー・フェーズ管理画面・フェーズ確定
 DATA_DIV_KYMW1300_PLAN_GOODS_COPE：商品企画マスタ画面・企画メンテファイル取込
 DATA_DIV_KYMW1300_COOP：商品企画マスタ画面・取扱生協CSVファイル取込
 DATA_DIV_KYMW1300_PROPOSALCARROT：商品企画マスタ画面・企画書シート（キャロット） 取込
 DATA_DIV_KYMW1314_PLAN_GOODS_COPE：商品企画マスタ画面・企画メンテファイル取込
 DATA_DIV_KYMW1314_COOP：商品企画マスタ画面・取扱生協CSVファイル取込
 */
export const enum KYMW0D00DataDiv {
  DATA_DIV_KYMW2900_PLAN_GOODS = '1',
  DATA_DIV_KYMW2900_COMMENT = '2',
  DATA_DIV_KYMW9400_CATALOG = '1',
  DATA_DIV_KYMW9400_USE_NUM_PEOPLE = '2',
  DATA_DIV_KYMW9400_DISTRIBUTION = '3',
  DATA_DIV_KYMW9400_BUDGET = '4',
  DATA_DIV_KYMW6300_JANCODE = '1',
  DATA_DIV_KYMW2700_PAGE_CHECK = '1',
  DATA_DIV_KYMW2700_PHASE = '2',
  DATA_DIV_KYMW1300_PLAN_GOODS_COPE = '1',
  DATA_DIV_KYMW1300_COOP = '2',
  DATA_DIV_KYMW1300_PROPOSALCARROT = '3',
  DATA_DIV_KYMW1314_PLAN_GOODS_COPE = '1',
  DATA_DIV_KYMW1314_COOP = '2',
}


/**
 * 処理ログ画面の値を管理するクラス
 *
 * @export KYMW0D00Model
 * @class KYMW0D00Model
 */
export class KYMW0D00Model {

  kymw0D00Component: KYMW0D00Component;

  /**
   * 処理ログ一覧ヘッダー項目
   */
  public headerText0: string = <string>'';  // 情報種類
  public headerText1: string = <string>'';  // 行
  public headerText2: string = <string>'';  // データ種別
  public headerText3: string = <string>'';  // 処理結果
  public headerText4: string = <string>'';  // 内容

  /**
   * 出力ボタンenabled
   */
  public btnOutputEnabled: boolean = <boolean>true;


  // 受渡情報
  /**
   * 受渡情報
   */
  public kymw0D00InputVO: KYMW0D00InputModel = null;

  // 保持情報
  /**
   * ファイルの出力有無
   */
  public outputFile: boolean = <boolean>false;

  /**
   * 処理ログリスト
   *
   * @type {Array<any>}
   * @memberof KYMW0D00Model
   */
  public logList: Array<any> = new Array<any>();

  /**
		 * 処理ログ一覧を更新する。
		 * @param serverData サーバからの受信データ
		 *
		 */
  public updateServerResponse(serverData: any): void {
    // 処理ログ一覧を初期化
    this.logList = null;

    // ヘッダー名称を設定
    this.headerText0 = '種類';
    this.headerText1 = '行';
    this.headerText3 = '処理結果';
    this.headerText4 = '内容';
    switch (this.kymw0D00InputVO.dispId) {
      case 'KYMW0A00':  // 組合員の声管理
        this.headerText2 = '受付番号';
        break;
      case 'KYMW1100':  // 商品マスタ
        this.headerText2 = 'eBASE仕様書No.';
        break;
      case 'KYMW1705':  // 包材画像一括登録
        this.headerText2 = '画像ファイル名';
        break;
      case 'KYMW2700':  // 基版コピー
      case 'KYMW2702':  // 基版コピー
        switch (this.kymw0D00InputVO.dataDiv) {
          case KYMW0D00DataDiv.DATA_DIV_KYMW2700_PAGE_CHECK: // 全ページチェック
            this.headerText2 = 'Pコード';
            break;
          case KYMW0D00DataDiv.DATA_DIV_KYMW2700_PHASE: // フェーズ確定
            this.headerText2 = '生協コード/カテゴリコード/Pコード';
            break;
          default:
            this.headerText2 = ' ';
        }
        break;
      case 'KYMW2900':  // 農産フロント連携
        this.headerText2 = '受注コード・アイテムコード';
        break;
      case 'KYMW9400':  // 外部システム連携
        switch (this.kymw0D00InputVO.dataDiv) {
          case KYMW0D00DataDiv.DATA_DIV_KYMW9400_CATALOG:
            this.headerText2 = '受注コード';
            break;
          case KYMW0D00DataDiv.DATA_DIV_KYMW9400_USE_NUM_PEOPLE:
            this.headerText2 = '生協コード・配達企画回';
            break;
          case KYMW0D00DataDiv.DATA_DIV_KYMW9400_DISTRIBUTION:
            this.headerText2 = '媒体区分';
            break;
          case KYMW0D00DataDiv.DATA_DIV_KYMW9400_BUDGET:
            this.headerText2 = '配達企画回';
            break;
          default:
            this.headerText2 = ' ';
        }
        break;
      case 'KYMW6300':  // 農産フロント連携
        this.headerText2 = 'JANコード';
        break;
      case 'KYMW9200':  // 企画回管理
        this.headerText2 = '受注コード';
        break;
      case 'KYMW5500':  // CWS画像メンテ
        this.headerText2 = '画像ファイル名';
        break;
      case 'KYMW1300': // 企画メンテファイル取込
        switch (this.kymw0D00InputVO.dataDiv) {
          case KYMW0D00DataDiv.DATA_DIV_KYMW1300_PLAN_GOODS_COPE:
            this.headerText2 = '受注コード・Ｐコード・生協コード';
            break;
          case KYMW0D00DataDiv.DATA_DIV_KYMW1300_COOP:
            this.headerText2 = '受注コード・Ｐコード・生協コード';
            break;
          case KYMW0D00DataDiv.DATA_DIV_KYMW1300_PROPOSALCARROT:
            this.headerText2 = '受注コード・利用生協コード・注文コード';
            break;
          default:
            this.headerText2 = ' ';
        }
        break;
      case 'KYMW1314': // EC提供用データ出力
        this.headerText2 = 'Ｐコード・生協コード';
        break;
      case 'KYMW0902':
        this.headerText2 = '受注コード・Ｐコード';
        break;
      case 'KYMW4400':
        this.headerText2 = '受注コード・媒体区分';
        break;
      default:
        this.headerText2 = ' ';
    }

    if (serverData == null) {
      return;
    }

    //  ArrayCollectionに変換して処理ログ一覧に設定
    this.logList = serverData;
    this.btnOutputEnabled = true;
  }

  /**
   * GetLogProcessResultVO取得
   */
  public getLogProcessResultVO(): any {
    const vo = {
      dispId: this.kymw0D00InputVO.dispId
    };
    return vo;
  }

  /**
   * MakeLogDataVO取得
   */
  public makeLogDataVO(): any {
    const vo = {
      localfile: this.localfile(),
      headerInfoKind: this.headerText0,
      headerLineNo: this.headerText1,
      headerDataKind: this.headerText2.trim(),
      headerProcessResult: this.headerText3,
      headerContents: this.headerText4,
      dispId: this.kymw0D00InputVO.dispId
    };
    return vo;
  }


  /**
   * DeleteLogProcessResultVO取得
   */
  public deleteLogProcessResultVO(): any {
    const vo = {
      dispId: this.kymw0D00InputVO.dispId
    };

    return vo;
  }

  /**
   * ローカルファイル名の設定
   */
  public localfile(): string {
    let fileName = '';
    switch (this.kymw0D00InputVO.dispId) {
      case 'KYMW0A00':  // 組合員の声管理
        fileName = 'リクエストデータ取込';
        break;
      case 'KYMW1100':  // 商品マスタ
        fileName = 'eBASEデータ取込';
        break;
      case 'KYMW1705':  // 包材画像一括登録
        fileName = '包材画像一括登録';
        break;
      case 'KYMW2600':  // W掲載リスト取込
        fileName = 'W掲載リスト取込';
        break;
      case 'KYMW2700':  // 基版コピー
      case 'KYMW2702':  // 基版コピー
        switch (this.kymw0D00InputVO.dataDiv) {
          case KYMW0D00DataDiv.DATA_DIV_KYMW2700_PAGE_CHECK:
            fileName = 'ページチェック結果';
            break;
          case KYMW0D00DataDiv.DATA_DIV_KYMW2700_PHASE:
            fileName = 'フェーズ確定結果';
            break;
        }
        break;
      case 'KYMW2900':  // 農産フロント連携
        switch (this.kymw0D00InputVO.dataDiv) {
          case KYMW0D00DataDiv.DATA_DIV_KYMW2900_PLAN_GOODS:
            fileName = '商品企画取込';
            break;
          case KYMW0D00DataDiv.DATA_DIV_KYMW2900_COMMENT:
            fileName = '産地コメント取込';
            break;
        }
        break;
      case 'KYMW9400':  // 外部システム連携
        switch (this.kymw0D00InputVO.dataDiv) {
          case KYMW0D00DataDiv.DATA_DIV_KYMW9400_CATALOG:
            fileName = '営業カレンダー取込';
            break;
          case KYMW0D00DataDiv.DATA_DIV_KYMW9400_USE_NUM_PEOPLE:
            fileName = '利用人数取込';
            break;
          case KYMW0D00DataDiv.DATA_DIV_KYMW9400_DISTRIBUTION:
            fileName = '按分比率取込';
            break;
          case KYMW0D00DataDiv.DATA_DIV_KYMW9400_BUDGET:
            fileName = '予算取込';
            break;
        }
        break;
      case 'KYMW6300':
        fileName = 'JANコード取込';
        break;
      case 'KYMW9200':  // 企画回管理
        fileName = '企画カレンダー取込';
        break;
      case 'KYMW5500':  // CWS画像メンテ
        fileName = 'EC画像更新結果';
        break;
      case 'KYMW1300':  // 企画メンテファイル,取扱生協CSVファイル,企画書シート（キャロット） 取込
        switch (this.kymw0D00InputVO.dataDiv) {
          case KYMW0D00DataDiv.DATA_DIV_KYMW1300_PLAN_GOODS_COPE:
            fileName = '企画メンテファイル取込';
            break;
          case KYMW0D00DataDiv.DATA_DIV_KYMW1300_COOP:
            fileName = '取扱生協CSVファイル取込';
            break;
          case KYMW0D00DataDiv.DATA_DIV_KYMW1300_PROPOSALCARROT:
            fileName = '企画書シート（キャロット）取込';
            break;
        }
        break;
      case 'KYMW1314':  // EC提供用データ出力
        fileName = 'ECデータ作成結果';
        break;
      case 'KYMW4400':												// 自動コマ配置
        fileName = '自動コマ配置';
        break;
      default:
        fileName = '';
    }
    return fileName;
  }
}
